module.exports = __webpack_public_path__ + "static/media/triodos.6bd941fb.png";